import { render, staticRenderFns } from "./SavedMoney.vue?vue&type=template&id=fa38fed8"
import script from "./SavedMoney.vue?vue&type=script&lang=js"
export * from "./SavedMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports